
import { AppContext } from "../../../App";
import { useContext } from "react";
import { NavLink, Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";


//Import Css
import './infoDevelopComponent.css';



export function InfoDevelopComponent({titleInfoDevelop, textInfoDevelop, photIconDev}) {


    const {

        iconsBrandsDevelop

    } = useContext (AppContext)


    return(

        <div className="box-info-develop">

            <div className="icon-info-develop">
                <h2 className="title-info-develop">{titleInfoDevelop}</h2>
                <div className="line-divisor"></div>
                <p className="text-info-develop">{textInfoDevelop}</p>

            </div>

            <div className="box-icons-develop">
                <img className="icons-develop incon-A" src={typeof photIconDev[0] === "number" ? iconsBrandsDevelop[photIconDev[0]] : ""} alt="Icon Develop" />  
                <img className="icons-develop incon-B" src={typeof photIconDev[1] === "number" ? iconsBrandsDevelop[photIconDev[1]] : ""} alt="Icon Develop" />                
                <img className="icons-develop incon-C" src={typeof photIconDev[2] === "number" ? iconsBrandsDevelop[photIconDev[2]] : ""} alt="Icon Develop" />                
                <img className="icons-develop incon-D" src={typeof photIconDev[3] === "number" ? iconsBrandsDevelop[photIconDev[3]] : ""} alt="Icon Develop" />                
              
            </div>

        </div>


    )
}

         